import React, { forwardRef } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  InputBase,
  MenuItem,
  Select,
  withStyles,
} from "@material-ui/core";
import { red, blue } from "@material-ui/core/colors";

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      position: "relative",
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

export const SelectComponent = forwardRef((props, _) => {
  const {
    label = "",
    value = {},
    name,
    onChange,
    options = [],
    error = "",
    small = false,
    defaultValue,
    disabled = false,
    noData = "No hay datos",
    multiple,
  } = props;
  const InputProps = { name, value };
  return (
    <FormControl variant="outlined" fullWidth disabled={disabled}>
      <InputLabel
        id="demo-simple-select-filled-label"
        placeholder={label}
        style={{
          backgroundColor: "white",
          padding: "1px 10px",
          borderRadius: 4,
        }}
      >
        {label}
      </InputLabel>
      {multiple ? (
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          onChange={onChange}
          variant="outlined"
          inputProps={InputProps}
          {...(small ? { value, input: <BootstrapInput /> } : { defaultValue })}
          renderValue={(selected) => (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
              {selected?.map((value) => {
                const selectedOption = options.find(
                  (opt) => opt.value === value
                );
                return (
                  <div
                    key={selectedOption?.value}
                    style={{
                      padding: 4,
                      backgroundColor: blue[700],
                      borderRadius: 4,
                      color: "white",
                      // border: `1px solid ${blue[700]}`
                    }}
                  >
                    {selectedOption?.label}
                  </div>
                );
              })}
            </div>
          )}
          {...props}
        >
          {options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          onChange={onChange}
          variant="outlined"
          inputProps={InputProps}
          // {...(small ? { value, input: <BootstrapInput /> } : { defaultValue })}
          value={value}
          {...props}
        >
          {options.length > 0 ? options.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  {opt.suggested && (
                    <div
                      style={{
                        width: 8,
                        height: 8,
                        backgroundColor: '#00e676',
                        borderRadius: '50%'
                      }}
                    />
                  )}
                  <span>{opt.label}</span>
                </div>
              </MenuItem>
            )) :
            <MenuItem disabled> {noData} </MenuItem>
          }
        </Select>
      )}
      <FormHelperText style={{ color: red[300] }}>{error}</FormHelperText>
    </FormControl>
  );
});
